import styled from '@emotion/styled'
export const StyleWrapper = styled.div<any>`
  height: calc(100dvh - 135px);
  width: calc(100% - 300px);
  background: #fafafa;
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
`
